<template>
  <v-flex
    class="sfh-login-header text-xs-center"
    :class="headerClass">

    <v-layout
      v-if="!isAuth && isCompactHeader"
      :style="isCompactHeader && {height: headerHeight}"
      align-center justify-space-between>
      <div style="width: 100%;">
        <router-link class="d-flex ml-2 router-link-active"  to="/">
          <img
            height="50"
            width="50"
            :src="appIcon"
            style="cursor:pointer;"
            :alt="appName" />
        </router-link>
        <h2
          class="white--text font-weight-regular line-height-1 pt-2 ml-2"
          v-text="appName"/>
      </div>
      <div>
        <v-toolbar-side-icon
          class="text-shadow notranslate" dark
          @click.stop="$store.commit('toggleGuestLeftDrawer', !guestLeftDrawer)"
        ></v-toolbar-side-icon>
      </div>
    </v-layout>

    <!-- For Sticky top --->
    <v-layout  v-if="!isAuth && !isCompactHeader" row align-center justify-center>
      <v-flex text-xs-left :style="{display: 'flex', 'align-items': 'center'}">
        <router-link class="d-flex ml-2 router-link-active"  to="/">
          <img :src="appIcon"
               height="50"
               width="50"
               :alt="appName">
        </router-link>

        <h2
          :class="titleClass()"
          class="white--text font-weight-regular float-left ml-2"
          :style="titleStyle()"><span v-text="title"/>
        </h2>
      </v-flex>
      <v-flex xs2 text-xs-right>
        <v-toolbar-side-icon class="text-shadow notranslate"  dark  @click.stop="$store.commit('toggleGuestLeftDrawer', !guestLeftDrawer)"
        ></v-toolbar-side-icon>
      </v-flex>
    </v-layout>

    <!--- USER LOGGED IN --->
    <div v-if="isAuth && isCompactHeader">
      <v-layout
        row wrap align-center justify-center user-logged-in
        :style="{height: headerHeight}">
        <v-flex xs2>
          <router-link class="d-flex ml-2 router-link-active"  to="/">
            <img
              height="50"
              width="50"
              :src="appIcon"
              style="cursor:pointer;"
              :alt="appName" />
          </router-link>
        </v-flex>
        <v-flex xs8></v-flex>
        <v-flex xs2 text-xs-right>
          <v-toolbar-side-icon  class="text-shadow notranslate"  dark  :class="currentStep === 3 ? 'current-step':''"
                                @click.stop="$store.commit('toggleRightDrawer', !rightDrawer)"
          ></v-toolbar-side-icon>
        </v-flex>
      </v-layout>
      <v-flex xs12 style="margin-top:-30px; height:60px;z-index: 1;position:relative; ">
          <div class="user-avatar elevation-10"
              :style="{ backgroundImage: 'url(' + $store.getters['user/avatar'] + ')',height:'90px',width:'90px' }"></div>
      </v-flex>
    </div>
    <!-- For Sticky top --->
    <v-layout  v-if="isAuth && !isCompactHeader" align-center justify-space-between py-2>
      <div class="d-flex align-center">
        <router-link class="d-flex ml-2 router-link-active"  to="/">
          <img :src="appIcon"
               height="50"
               width="50"
               :alt="appName" />
        </router-link>
        <span style="font-size: 20px;" class="pl-2">
          <span class="white--text font-weight-regular float-left mt-2 line-height-1 ml-2"
             style="text-align: left;" v-html="title" />
          <span v-if="$store.getters.getPageSubTitle"
                class="text-xs-left white--text font-italic" v-text="$store.getters.getPageSubTitle"/>
        </span>
      </div>
      <div>
        <v-toolbar-side-icon  dark   class="text-shadow notranslate"  :class="currentStep === 3 ? 'current-step':''"
                              @click.stop="$store.commit('toggleRightDrawer', !rightDrawer)"
        ></v-toolbar-side-icon>

      </div>
    </v-layout>


    <navigation-menu></navigation-menu>
    <guest-left-navigation-menu></guest-left-navigation-menu>
  </v-flex>

</template>

<script>
  import NavigationMenu from './NavigationMenu'
  import GuestLeftNavigationMenu from './GuestLeftNavigationMenu'
  import { DEVICE_WIDTH, SINGLE_LINE_MAX_TITLE_LEN } from '@/mixins/constants'

  const { I_PHONE_5, I_PHONE_X, I_PAD } = DEVICE_WIDTH

  export default {
    name: 'Header',
    components: {
      GuestLeftNavigationMenu,
      NavigationMenu
    },
    props: {
      className: {
        default: '',
        type: String
      },
      headerHeight: {
        default: '70px',
        type: String
      }
    },
    data () {
      return {
        clipped: false,
        hasAvatar: true,
        appName: process.env.APP_NAME,
        appIcon: require('@/assets/logos/' + process.env.APP_ICON)
      }
    },
    computed: {
      headerClass () {
        if (this.className) {
          return this.className
        } else
        if (this.isAuth) {
          if (this.isCompactHeader) {
            return 'pa-1'
          } else {
            return 'pa-1 text-xs-left'
          }
        } else {
          if (this.isCompactHeader) {
            return 'pt-2 pb-3'
          } else {
            const py = this.appWidth <= I_PHONE_5 ? 'py-1' : 'py-3'
            return `${py} text-xs-left`
          }
        }
      },
      title: {
        get: function () {
          let title = typeof this.$route.meta.pageTitle !== 'undefined' ? this.$route.meta.pageTitle : ''
          if (this.$route.name === 'ProgramLevels') {
            title = this.$store.getters.getPageTitle
          }

          return title
        },
        set: function () {
        }
      },
      isCompactHeader: {
        get: function () {
          return this.$store.getters.getIsCompactHeader
        },
        set: function (val) {
          this.$store.commit('setIsCompactHeader', val)
        }
      },
      currentStep: {
        get: function () {
          return this.$store.getters.getTourCurrentStep
        },
        set: function () {
          // setting db object
        }
      },
      isAuth () {
        return this.$auth.check()
      },
      userDetails () {
        return this.$store.getters['user/getUserDetails']
      },
      avatarLetters () {
        return this.$store.getters['user/avatarLetters']
      },
      username () {
        return localStorage.getItem('email')
      },
      rightDrawer: {
        get: function () {
          return this.$store.getters.rightDrawer
        },
        set: function (value) {
          this.$store.commit('toggleRightDrawer', value)
        }
      },
      guestLeftDrawer: {
        get: function () {
          return this.$store.getters.guestLeftDrawer
        },
        set: function (value) {
          this.$store.commit('toggleGuestLeftDrawer', value)
        }
      },
      appWidth () {
        return this.$store.getters.getAppWidth
      }
    },
    created () {
      // eslint-disable-next-line no-console
      // console.log('this.isAuth', this.isAuth)
      // eslint-disable-next-line no-console
      // console.log('localStorage.email', localStorage.getItem('email'))
      // this.me()
    },
    methods: {
      // me () {
      //   const url = process.env.GAME_ID === 52 ? `${this.apiUrl}/ws/playerservice/user/${this.username}` : `${this.apiUrl}/ws/playerservice/user/${this.username}?deck=${process.env.GAME_ID}`
      //   this.$http({
      //     url,
      //     method: 'GET',
      //     headers: {
      //       Authorization: 'Bearer ' + this.$auth.token()
      //     }
      //   }).then((res) => {
      //     this.$auth.user(res.data)
      //     this.$auth.watch.authenticated = true
      //
      //     if (this.rememberMe) {
      //       localStorage.setItem('login_user_name', this.username)
      //       localStorage.setItem('login_password', this.password)
      //       localStorage.setItem('login_remember_me', 'yes')
      //     } else {
      //       localStorage.setItem('login_user_name', '')
      //       localStorage.setItem('login_password', '')
      //       localStorage.setItem('login_remember_me', 'no')
      //     }
      //
      //     document.cookie = 'user_name=' + res.data.friendlyName + ';domain=cogneti.com'
      //     document.cookie = 'user_email=' + res.data.email + ';domain=cogneti.com'
      //     localStorage.setItem('user_name', res.data.friendlyName)
      //     const countryId = res.data.countryId !== null ? res.data.countryId : 233
      //
      //     this.$store.commit('user/setCountry', countryId)
      //     this.$store.commit('user/setUserDetails', res.data)
      //     this.$store.commit('user/setAvatar', res.data.userImageUrl)
      //     this.$store.commit('user/setFirstName', res.data.firstName)
      //     this.$store.commit('user/setLastName', res.data.lastName)
      //     this.$store.commit('user/setUserId', res.data.id)
      //     this.$store.commit('user/setState', res.data.stateId)
      //     this.$store.commit('user/setPhone', res.data.phoneNumber)
      //     this.$store.commit('user/setAddressLine1', res.data.addressLine1)
      //     this.$store.commit('user/setAddressLine2', res.data.addressLine2)
      //     this.$store.commit('user/setCity', res.data.city)
      //     this.$store.commit('user/setPostalCode', res.data.postalCode)
      //     const keyEmail = localStorage.getItem('email')
      //     if (typeof keyEmail === 'undefined' || keyEmail !== res.data.email) {
      //       localStorage.setItem('email', res.data.email)
      //       this.$store.commit('setDashboardTourStart', 0)
      //       this.$store.commit('setNewUserLoggedin', true)
      //       this.$store.commit('setTourStatus', true)
      //       this.$store.commit('setLearnStatus', true)
      //       this.$store.commit('setQuizStatus', true)
      //       this.$store.commit('course/setLastPlayedLevel', 0)
      //       this.$store.commit('course/setLevels', [])
      //       this.$store.commit('course/setGroups', [])
      //       this.$store.commit('course/setMemberId', 0)
      //       this.$store.commit('course/setBadgeScore', -1)
      //       this.$store.commit('course/setCourseLevelLoadedAfterLogin', false)
      //     } else {
      //       this.$store.commit('setNewUserLoggedin', false)
      //     }
      //   }).then(() => {
      //     this.$http({
      //       url: `${this.apiUrl}/ws/compliance/programs/course/${process.env.GAME_ID} `,
      //       method: 'GET',
      //       headers: {
      //         Authorization: 'Bearer ' + this.$auth.token()
      //       }
      //     }).then((res) => {
      //       this.$store.commit('complianceProgram/setPrograms', res.data)
      //     })
      //   })
      // },
      titleClass () {
        return this.title.length > SINGLE_LINE_MAX_TITLE_LEN ? 'mt-2 line-height-1' : 'line-height-1-2'
      },
      titleStyle () {
        const fontSize = this.appWidth >= I_PAD ? '1.5em' : '1.4em'
        const marginRight = this.appWidth < I_PHONE_X ? '10px' : 'auto'
        return {
          textAlign: 'left',
          fontSize,
          marginRight
        }
      },
      openRoute (route) {
        if (route === '/') {
          const route = Object.keys(this.userDetails).length > 0 ? 'Programs' : 'Home'
          this.$router.push({name: route})
        } else {
          this.$router.push({name: route})
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layouts/HeaderDefault.vue